import { render, staticRenderFns } from "./GestioneAttivitaProdottiEditPage.vue?vue&type=template&id=2fc5c0d8"
import script from "./GestioneAttivitaProdottiEditPage.vue?vue&type=script&lang=js"
export * from "./GestioneAttivitaProdottiEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports